<h4 matDialogTitle data-cy="add-payment-title">View\Add a Payment</h4>

<mat-dialog-content>
  <ng-container *ngIf="vm$ | async as vm">
    <table class="table table-striped" data-cy="payments-table">
      <thead *ngIf="vm.payments.length > 0">
        <tr>
          <th>Amount</th>
          <th>Method</th>
          <th>Received By</th>
          <th>Date Received</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let payment of vm.payments">
          <td>
            {{
              payment.amount
                | hlCurrency: data.currency : data.currencyRate
                | async
            }}
          </td>
          <td>{{ payment.method }}</td>
          <td>{{ payment.user_id | userIdToName | async }}</td>
          <td>{{ payment.created_at | amDateFormat: dateTimeFormat }}</td>
          <td>
            <button
              data-cy="delete-payment"
              mat-icon-button
              (click)="delete(payment)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <p data-cy="no-payments-message" *ngIf="vm.payments.length === 0">
      <em> No payments yet </em>
    </p>
    <p data-cy="dialog-paid" *ngIf="vm.payments.length > 0">
      <strong>Total Paid:</strong>
      {{ vm.totalPaid | hlCurrency: data.currency : data.currencyRate | async }}
    </p>
    <p data-cy="dialog-balance">
      <strong>Balance:</strong>
      {{ vm.balance | hlCurrency: data.currency : data.currencyRate | async }}
    </p>

    <form [formGroup]="newPayment" class="flex flex-col mt-4 items-stretch">
      <mat-form-field>
        <mat-select
          autofocus
          placeholder="Payment Method"
          name="Payment Method"
          id="method"
          data-cy="payment-method"
          formControlName="method"
          required="true"
        >
          <mat-option *ngFor="let method of methods" [value]="method"
            >{{ method }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Amount Paid</mat-label>
        <span matPrefix [appAddCurrencyPrefix]="data.currency"></span>
        <input
          type="number"
          min="0"
          placeholder="Amount"
          matInput
          required
          name="Amount"
          data-cy="payment-amount"
          formControlName="amount"
        />
      </mat-form-field>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close()" data-cy="close-payment">
    Close
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    data-cy="save-payment"
    [disabled]="newPayment.valid !== true || (loading$ | async)"
  >
    Save
  </button>
</mat-dialog-actions>
